"use strict";

import secureLinkContent from "./utils/secureLinkContent.js";

let SecureEmail = {
    options: {
        selector: 'a[class="secure-email"]',
    },
};

SecureEmail.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

SecureEmail.initSelectors = function (rootElement) {
    const elements = rootElement.querySelectorAll(this.options.selector);
    elements.forEach(function (element) {
        if (element.hasOwnProperty('moduleSecureEmailInitialized')) { return; }
        element.moduleSecureEmailInitialized = true;

        const name = element.getAttribute("data-name");
        const domainStart = element.getAttribute("data-domain-start");
        const domainEnd = element.getAttribute("data-domain-end");
        const icon = element.getAttribute("data-icon");
        const address = name + "@" + domainStart + "." + domainEnd;
        element.setAttribute("href", "mailto:" + address);
        element.replaceChildren(...secureLinkContent(icon, address));
    });
}

export {SecureEmail};